module.exports = "<toggler-component [state]=\"value\" (onChange)=\"toggle()\" [disabled]=\"disabled\"></toggler-component>"